module.exports = __webpack_public_path__ + "img/Bear07.99f80d91.png";